import { useEffect, useRef } from 'react';
import { useRotationStore } from 'src/context/RotationContext';
import { useStowageStore } from 'src/context/StowageContext';
import { useVesselStore } from 'src/context/VesselContext';
import { useViolationsStore } from 'src/context/ViolationsContext';
import { StowagePlanRulesManager, StowageRulesOptions } from 'src/utils/stowage/stowageRulesManager/stowagePlanRulesManager';
import { updateViolations } from 'src/utils/stowage/violations/violationsUtils';
import useEffectUtils from 'src/utils/useEffectUtils';

const useUpdateViolations = () => {
    const { selectedVessel } = useVesselStore();
    const { activeStowagePlan, manifest, isStowagePlanUpdated } = useStowageStore();
    const { setViolations, savedViolations } = useViolationsStore();
    const { coatingCompatibilities, uscgCompatibilities, coatingList } = useRotationStore();
    const { logChangedProperties, getPropertiesFromArray } = useEffectUtils();

    const propertiesToMonitor = [
        'activeStowagePlan',
        'selectedVessel',
        'manifest',
        'coatingCompatibilities',
        'coatingList',
        'isCoatingCompatibilitiesUpdated',
        'uscgCompatibilities',
    ];
    const previousValues = useRef(getPropertiesFromArray(propertiesToMonitor, { activeStowagePlan, selectedVessel, manifest }));

    useEffect(() => {
        if (!isStowagePlanUpdated || !activeStowagePlan || !selectedVessel || !manifest || !coatingCompatibilities || !coatingList) return;

        previousValues.current = logChangedProperties(
            previousValues.current,
            propertiesToMonitor,
            getPropertiesFromArray(propertiesToMonitor, { activeStowagePlan, selectedVessel, manifest })
        );

        const newViolations = new StowagePlanRulesManager().verifyStowageRules(
            {} as StowageRulesOptions,
            activeStowagePlan,
            selectedVessel,
            null,
            null,
            coatingCompatibilities,
            uscgCompatibilities
        );
        const updatedViolationsResponse = updateViolations(savedViolations ?? [], newViolations);
        setViolations(updatedViolationsResponse.updatedViolations);
    }, [isStowagePlanUpdated, activeStowagePlan, selectedVessel, manifest, coatingCompatibilities, coatingList, uscgCompatibilities]);
};
export default useUpdateViolations;
